import { memo, useCallback, useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Processing from '@wg/wows-react-uikit/components/Processing/Processing';

import { root } from '~/preloaded';
import useTargetClanId from '~/hooks/useTargetClanId';
import { ROUTES_MAP } from '~/router/routes';
import { useAppDispatch, useAppSelector } from '~/store';
import { clanSelector } from '~/store/selectors/clanSelectors';
import { currentAccountSelector } from '~/store/selectors/currentAccountSelector';
import { fetchClan, fetchMembers } from '~/Actions/ActionClanProfile';

import { IsFromSearchContext } from '~/Providers/IsFromSearch';

import styles from './ClanMembers.module.scss';
import ClanMembersContent from './ClanMembersContent';

const ClanMembers = () => {
  const dispatch = useAppDispatch();
  const isFromSearch = useContext(IsFromSearchContext);

  const currentAccount = useAppSelector(currentAccountSelector);
  const { clanId } = useTargetClanId(currentAccount.clanId);

  const clan = useAppSelector((state) => {
    return clanId ? clanSelector(state, clanId) : null;
  });

  const fetchData = useCallback(() => {
    if (!clanId) {
      return;
    }

    void dispatch(fetchClan(clanId));
    void dispatch(fetchMembers(clanId));
  }, [dispatch, clanId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (!clanId) {
    return <Navigate to={`${root}${ROUTES_MAP.ROOT}`} replace />;
  }

  if (!clan) {
    return <Processing isFetching className={styles.processing} />;
  }

  return <ClanMembersContent clanId={clanId} currentAccount={currentAccount} isFromSearch={isFromSearch} />;
};

export default memo(ClanMembers);
